export const ARRIVING_TODAY = 'Arriving today';
export const ARRIVING_TOMORROW = 'Arriving tomorrow';
export const NEXT_7_DAYS = 'Carriers en route';
